import { ChangeDetectorRef, Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Unidades } from "src/app/models/unidades.model";
declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-unidades",
    templateUrl: "./unidades.component.html",
    styleUrls: ["./unidades.component.css"],
    providers: [FormService]
})

export class UnidadesComponent {

    public rows = [];
    public actualRow;
    public unidades: Unidades;
    public form;
    public totalUni;
    public totalUniMod;

    public numberForm;

    public form131;
    public form251;
    public form252;
    public form253;
    public form254;
    public form255;

    matcher = new FormService();

    constructor(public _formService: FormService, private fb: FormBuilder, private _changeDetectionRef: ChangeDetectorRef) {

        this.numberForm = localStorage.getItem("form");

        if (this.numberForm == "1-3.1") {
            this.form131 = true;
        }
        if (this.numberForm == "2-5.1") {
            this.form251 = true;
        }
        if (this.numberForm == "2-5.2") {
            this.form252 = true;
        }
        if (this.numberForm == "2-5.3") {
            this.form253 = true;
        }
        if (this.numberForm == "2-5.4") {
            this.form254 = true;
        }
        if (this.numberForm == "2-5.5") {
            this.form255 = true;
        }


        this.form = new FormGroup({
            vivienda: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            oficinas: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            locales: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            bodega: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            cantidad: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            est_autos: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            est_bicis: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            otrosEsp: new FormControl(''),
            otrosCant: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            otrosEsp2: new FormControl(''),
            otrosCant2: new FormControl(0, [Validators.pattern(/^[0-9]\d*$/)]),
            otros: new FormControl(""),
            total: new FormControl(0),


            /* Modificacion */
            viviendaMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            oficinasMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            localesMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            bodegaMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            cantidadMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            est_autosMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            est_bicisMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            otrosEspMod: new FormControl(''),
            otrosCantMod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            otrosEsp2Mod: new FormControl(''),
            otrosCant2Mod: new FormControl(0, Validators.pattern(/^[0-9]\d*$/)),
            otrosMod: new FormControl(""),
            totalMod: new FormControl(0)
        })
        if (!JSON.parse(localStorage.getItem("unidades"))) {
            localStorage.setItem("unidades", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("unidades"));

            this.form.controls['vivienda'].setValue(this.rows[0] ? this.rows[0].vivienda : 0)
            this.form.controls['oficinas'].setValue(this.rows[0] ? this.rows[0].oficinas : 0)
            this.form.controls['locales'].setValue(this.rows[0] ? this.rows[0].locales : 0)
            this.form.controls['bodega'].setValue(this.rows[0] ? this.rows[0].bodega : 0)
            this.form.controls['cantidad'].setValue(this.rows[0] ? this.rows[0].cantidad : 0)
            this.form.controls['total'].setValue(this.rows[0] ? this.rows[0].total : 0)

            this.form.controls['est_autos'].setValue(this.rows[0] ? this.rows[0].est_autos : 0)
            this.form.controls['est_bicis'].setValue(this.rows[0] ? this.rows[0].est_bicis : 0)
            this.form.controls['otros'].setValue(this.rows[0] ? this.rows[0].otros : "")
            this.form.controls['otrosEsp'].setValue(this.rows[0] ? this.rows[0].otrosEsp : '')
            this.form.controls['otrosCant'].setValue(this.rows[0] ? this.rows[0].otrosCant : 0)
            this.form.controls['otrosEsp2'].setValue(this.rows[0] ? this.rows[0].otrosEsp2 : '')
            this.form.controls['otrosCant2'].setValue(this.rows[0] ? this.rows[0].otrosCant2 : 0)


            this.form.controls['viviendaMod'].setValue(this.rows[0] ? this.rows[0].viviendaMod : 0)
            this.form.controls['oficinasMod'].setValue(this.rows[0] ? this.rows[0].oficinasMod : 0)
            this.form.controls['localesMod'].setValue(this.rows[0] ? this.rows[0].localesMod : 0)
            this.form.controls['bodegaMod'].setValue(this.rows[0] ? this.rows[0].bodegaMod : 0)
            this.form.controls['cantidadMod'].setValue(this.rows[0] ? this.rows[0].cantidadMod : 0)
            this.form.controls['totalMod'].setValue(this.rows[0] ? this.rows[0].totalMod : 0)

            this.form.controls['est_autosMod'].setValue(this.rows[0] ? this.rows[0].est_autosMod : 0)
            this.form.controls['est_bicisMod'].setValue(this.rows[0] ? this.rows[0].est_bicisMod : 0)
            this.form.controls['otrosMod'].setValue(this.rows[0] ? this.rows[0].otrosMod : "")
            this.form.controls['otrosEspMod'].setValue(this.rows[0] ? this.rows[0].otrosEspMod : '')
            this.form.controls['otrosCantMod'].setValue(this.rows[0] ? this.rows[0].otrosCantMod : 0)
            this.form.controls['otrosEsp2Mod'].setValue(this.rows[0] ? this.rows[0].otrosEsp2Mod : '')
            this.form.controls['otrosCant2Mod'].setValue(this.rows[0] ? this.rows[0].otrosCant2Mod : 0)
        }
        this.unidades = {
            vivienda: 0,
            oficinas: 0,
            locales: 0,
            bodega: 0,
            cantidad: 0,
            total: 0,
            est_autos: 0,
            est_bicis: 0,
            otros: "",
            otrosEsp:"",
            otrosCant: 0,
            otrosEsp2: "",
            otrosCant2: 0,

            viviendaMod: 0,
            oficinasMod: 0,
            localesMod: 0,
            bodegaMod: 0,
            otrosMod: "",
            cantidadMod: 0,
            totalMod: 0,
            est_autosMod: 0,
            est_bicisMod: 0,
            otrosEspModMod: "",
            otrosCantMod: 0,
            otrosEsp2Mod: "",
            otrosCant2Mod: 0,
        };

    }

    add_unidades() {

        this.totalUni = parseInt(this.form.value.vivienda) + parseInt(this.form.value.oficinas) + parseInt(this.form.value.locales) + parseInt(this.form.value.bodega) + parseInt(this.form.value.cantidad) 
        this.totalUniMod = parseInt(this.form.value.viviendaMod) + parseInt(this.form.value.oficinasMod) + parseInt(this.form.value.localesMod) + parseInt(this.form.value.bodegaMod) + parseInt(this.form.value.cantidadMod)
        this.form.controls['total'].setValue(this.totalUni)
        this.form.controls['totalMod'].setValue(this.totalUniMod)
        this._changeDetectionRef.detectChanges();


        localStorage.setItem("unidades", JSON.stringify([]));
        this.actualRow = localStorage.getItem("unidades");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            vivienda: this.form.value.vivienda,
            oficinas: this.form.value.oficinas,
            locales: this.form.value.locales,
            bodega: this.form.value.bodega,
            cantidad: this.form.value.cantidad,
            total: this.totalUni,
            est_autos: this.form.value.est_autos,
            est_bicis: this.form.value.est_bicis,
            otros: this.form.value.otros,
            otrosEsp: this.form.value.otrosEsp,
            otrosCant: this.form.value.otrosCant,
            otrosEsp2: this.form.value.otrosEsp2,
            otrosCant2: this.form.value.otrosCant2,

            viviendaMod: this.form.value.viviendaMod,
            oficinasMod: this.form.value.oficinasMod,
            localesMod: this.form.value.localesMod,
            bodegaMod: this.form.value.bodegaMod,
            cantidadMod: this.form.value.cantidadMod,
            totalMod: this.totalUniMod,
            est_autosMod: this.form.value.est_autosMod,
            est_bicisMod: this.form.value.est_bicisMod,
            otrosMod: this.form.value.otrosMod,
            otrosEspMod: this.form.value.otrosEspMod,
            otrosCantMod: this.form.value.otrosCantMod,
            otrosEsp2Mod: this.form.value.otrosEsp2Mod,
            otrosCant2Mod: this.form.value.otrosCant2Mod
        })
        localStorage.setItem("unidades", JSON.stringify(this.rows));
    }

    delete_unidades(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("unidades", JSON.stringify(this.rows));
            }
        }
    }



}